import React from 'react';
import BadgeCmp from 'src/components/BadgeCmp';
import { getFormattedDateWithTime } from 'src/utils/CommonFunctions';

import { getLatestPodUploadedAt } from '../documentHub.helper';

import DaysPendingBadge from './DaysPendingBadge';

const getStatusBadgeType = (status: string): 'success' | 'warning' | 'error' | 'gray' => {
    switch (status?.toLowerCase()) {
        case 'paid':
            return 'success';
        case 'pending':
            return 'warning';
        case 'overdue':
            return 'error';
        default:
            return 'gray';
    }
};

const InvoiceDraggableCell = ({ columnName, data }: { columnName: string; data: any }) => {
    if (data === null || data === undefined) return <>-</>;

    switch (columnName) {
        case 'Invoice':
            return <span className="text-utilityBlack800 font-semibold truncate">{data?.invoiceNumber || '-'}</span>;
        case 'Order ID':
            return <span className="truncate text-utilityBlack800 font-semibold">{data?.orderId || '-'}</span>;
        case 'Status':
            return (
                <BadgeCmp style="modern" type={getStatusBadgeType(data?.status)}>
                    {data?.status || '-'}
                </BadgeCmp>
            );
        case 'Due Date':
            return <span>{data?.dueDate ? getFormattedDateWithTime(data.dueDate) : '-'}</span>;
        case 'Date Invoiced':
            return <span>{data?.dateInvoiced ? getFormattedDateWithTime(data.dateInvoiced) : '-'}</span>;
        case 'Last Updated':
            return <span>{data?.lastUpdated ? getFormattedDateWithTime(data.lastUpdated) : '-'}</span>;
        case 'Total Price':
            return <span>{data?.totalPrice || '-'}</span>;
        case 'Payment Terms':
            return <span>{data?.paymentTerms || '-'}</span>;

        case 'Days Pending':
            // Same component as the real column, so the drag preview can never drift from it (both
            // previously carried their own copy of the inverted colour logic).
            return <DaysPendingBadge daysPending={data?.daysPending} status={data?.status} />;
        case 'POD':
            // Same "View POD" text link the real column renders.
            return data?.podDocuments?.length ? <span className="text-utilityBlack800 font-semibold">View POD</span> : <>-</>;

        case 'POD Upload Date': {
            const podUploadedAt = getLatestPodUploadedAt(data);

            return <span>{podUploadedAt ? getFormattedDateWithTime(podUploadedAt) : '-'}</span>;
        }
        default:
            return <>-</>;
    }
};

export default InvoiceDraggableCell;
